import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { useParams } from "react-router-dom";
import { Ref } from "../../../../core/components/Ref";
import { TextComponent } from "../../../../core/components/TextComponent";
import { ExternalLinkIcon } from "../../../../core/icons/ExternalLink";
import { Button } from "../../../../core/components/Button";
import { CheckIcon } from "../../../../core/icons/Check";
import { CopyIcon } from "../../../../core/icons/Copy";
import { useState } from "react";

export const LotterySuccess: React.FC = () => {
	const { id } = useParams();
	const [isLinkCopied, setIsLinkCopied] = useState(false);
	const link = window.location.href.replace("/success", "");
	const handleCopyLink = () => {
		navigator.clipboard
			.writeText(link)
			.then(() => {
				setIsLinkCopied(true);
				setTimeout(() => {
					setIsLinkCopied(false);
				}, 3000);
			})
			.catch((error) => {
				console.error("Error al copiar el enlace: ", error);
			});
	};

	return (
		<Column className="py-5 px-5 gap-3 md:gap-4">
			<TextComponent
				variant="h1"
				className="tracking-wider text-orange-500 uppercase text-center font-lilita-one"
			>
				¡Tu sorteo ha sido creado con éxito!
			</TextComponent>
			<TextComponent
				variant="h3"
				className="text-gray-700 text-center"
			>
				Comparte este <strong>enlace</strong> con quien quieras y todos podrán seguir los <strong>resultados</strong> en <strong>tiempo real</strong>.
			</TextComponent>
			<TextComponent
				variant="h5"
				className="border px-4 py-3 rounded truncate"
			>
				{link}
			</TextComponent>
			<Column className="w-full gap-2">
				<Ref
					className="font-bold"
					href={`/lottery/${id}`}
					color="orange"
					secondary
				>
					<Row
						className="gap-1"
						crossAxisAlignment="center"
						mainAxisAlignment="center"
					>
						<ExternalLinkIcon className="w-5 h-5" />
						<span>Ir al sorteo</span>
					</Row>
				</Ref>
				<Button
					className="font-bold"
					onClick={handleCopyLink}
					isDisabled={isLinkCopied}
					color="yellow"
				>
					<Row
						className="gap-1"
						crossAxisAlignment="center"
						mainAxisAlignment="center"
					>
						{isLinkCopied ? <CheckIcon className="w-5 h-5" /> : <CopyIcon className="w-5 h-5" />}
						<span>{isLinkCopied ? "¡El enlace ha sido copiado!" : "Copiar enlace de sorteo"}</span>
					</Row>
				</Button>
			</Column>
		</Column>
	);
};
